import styled from 'styled-components';
import { spacing5, neutral10 } from '@leaftrade/leaftrade-component-library';

export const CartLineItemsHeaderWrapper = styled.div`
  display: flex;
  padding-bottom: ${spacing5};
  border-bottom: 1px solid ${neutral10.hex};
`;
